// Based on '@mui/icons-material/RadioButtonChecked'

export const svgPathData = 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z';
export const svgPath = `path://${svgPathData}`;
